import { TextField } from '@radix-ui/themes'
import React from 'react'
import styled from 'styled-components'

import {
  InputAndSubtitle,
  StyledInputContainer,
  StyledLabel,
  StyledTextFieldSlot,
  SubtitleRowStyled,
  SubtitleTextStyled,
  TextValue,
} from './InputStyles'

export interface NumberInputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  $label?: string
  $labelColor?: string
  $labelLocation?: 'top' | 'side'
  $subtitleText?: string
  $subtitleTextColor?: string
  $backgroundColor?: string
  $borderColor?: string
  mode?: 'read' | 'edit'
  units?: string
  ref?: React.ForwardedRef<HTMLInputElement>
}

const InputStyled = styled(TextField.Root)<NumberInputProps>`
  & > input {
    padding: 0.25rem;
  }

  font-family: ${({ theme }) => theme.fontFamily.manrope};
  color: ${({ theme }) => theme.forecast.defaultText};
  background-color: ${({ $backgroundColor, theme }) =>
    $backgroundColor ? $backgroundColor : theme.forecast.cardGroupBackground};
  border-radius: 0.25rem;
  border: ${(props) =>
    props.$borderColor
      ? `1px solid ${props.$borderColor}`
      : '1px solid transparent'};
  font-weight: 600;
  box-shadow: none !important;
  opacity: 1;

  &:hover {
    cursor: pointer;
  }

  &:focus {
    cursor: initial;
  }
`

export const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>(
  (props, ref) => {
    const {
      $label,
      $labelColor,
      $labelLocation,
      $subtitleText,
      $subtitleTextColor,
      units,
      mode,
    } = props

    return (
      <StyledInputContainer $labelLocation={$labelLocation}>
        {$label && (
          <StyledLabel $labelColor={$labelColor} htmlFor={$label}>
            {$label}
          </StyledLabel>
        )}

        <InputAndSubtitle>
          {mode === 'read' ? (
            <TextValue>
              {props.defaultValue}
              <StyledTextFieldSlot side='right'>{units}</StyledTextFieldSlot>
            </TextValue>
          ) : (
            <InputStyled {...props} ref={ref}>
              <StyledTextFieldSlot side='right'>{units}</StyledTextFieldSlot>
            </InputStyled>
          )}

          {mode !== 'read' && $subtitleText && (
            <SubtitleRowStyled>
              <SubtitleTextStyled $subtitleTextColor={$subtitleTextColor}>
                {$subtitleText}
              </SubtitleTextStyled>
            </SubtitleRowStyled>
          )}
        </InputAndSubtitle>
      </StyledInputContainer>
    )
  }
)
NumberInput.displayName = 'NumberInput'
